import { Progress } from "flowbite-react";
import { useEffect, useRef, useState } from "react";
import { Link, Outlet, useLocation, useOutletContext } from "react-router-dom";
import Icon from "../assets/images/icon.svg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import type { Data } from "../types";
import { getCategories } from "../lib/data";

type ScreenContext = {
  submitLabel?: string;
  nextPath: string;
  progress: number;
  votting?: boolean;
  topics?: Array<any>;
  urlParams?: Object;
  userPreferences?: Object;
  booksUnliked?: Array<number>;
};

export const Option = ({
  children,
  onClick,
}: {
  children: any;
  onClick: () => void;
}) => {
  const ref = useRef() as any;

  const handleClick = () => {
    onClick();
    ref.current.classList.toggle("bg-amber-200");
  };

  return (
    <button
      ref={ref}
      type="button"
      className="text-md font-md my-2 w-full rounded-md bg-amber-100 px-5 py-2.5 text-gray-900"
      onClick={handleClick}
    >
      {children}
    </button>
  );
};

function Layout() {
  const { t } = useTranslation();

  const [screenData, setScreenData] = useState<ScreenContext>({
    submitLabel: t("layout.cta_continue"),
    nextPath: "age",
    progress: 7,
    votting: false,
    urlParams: {},
    userPreferences: {},
    booksUnliked: [],
  });

  useEffect(() => {
    getCategories()
      .then((response) => response.json())
      .then((response) =>
        setScreenData({ ...screenData, topics: response.data })
      );
  }, []);

  console.log(screenData);

  return (
    <div className="container mx-auto max-w-screen-sm p-4 text-center">
      <header>
        <Progress progress={screenData.progress} color="blue" size="sm" />
        <div className="py-4">
          <img className="h-8 w-8 rounded-full" src={Icon} alt="12min Logo" />
        </div>
      </header>
      <div>
        <Outlet context={[screenData, setScreenData]} />
      </div>
      {screenData.submitLabel && (
        <div className="fixed inset-x-0 bottom-0 mx-auto max-w-screen-sm bg-gradient-to-t from-white via-white">
          <div className="mx-4">
            {!screenData.votting && (
              <Link to={screenData.nextPath}>
                <button
                  type="button"
                  className="text-md my-6 w-full rounded-md bg-blue-700 px-5 py-2.5 font-normal text-white hover:bg-blue-800 focus:ring-blue-300"
                >
                  {screenData.submitLabel}
                </button>
              </Link>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export function useScreenContext(): any {
  return useOutletContext<ScreenContext>();
}

export default Layout;
